import i18next from 'i18next';
import { __DEBUG__, DEFAULT_LANGUAGE } from '../constants';

import nl from './locales/nl.json';
import en from './locales/en.json';

i18next.init({
  fallbackLng: DEFAULT_LANGUAGE,
  fallbackNS: ['translation'],
  resources: {
    nl,
    en,
  },
  parseMissingKeyHandler: (missing, fallback) => {
    if (__DEBUG__) {
      console.warn('MISSING TRANSLATION:', missing);
    }
    return fallback || missing;
  },
});

i18next.languages = ['nl', 'en'];

export default i18next;
